import type FeatureFlagsCompany from '@/model/FeatureFlagsCompany'
import type { FeatureFlagsGlobal } from '@/model/FeatureFlagsGlobal'

export function resolveTransportDocumentV2SchemaEnabled(
  companyFlags?: FeatureFlagsCompany | null,
  globalFlags?: FeatureFlagsGlobal | null
): boolean {
  if (companyFlags?.transportDocumentV2SchemaEnabled != null) {
    return companyFlags.transportDocumentV2SchemaEnabled === true
  }
  return globalFlags?.transportDocumentV2SchemaEnabled === true
}
